import { Geometry } from '@barthauer/basys/map-frame';

export class MtObject {
  Id: string;
  ObjectType: number;
  Designation: string;
  GeObjectId: string;
  GeObjectType: number;
  Type: string;
  Street: string;
  Note: string;
  Works: MtWork[];
  InvisibleValues: {};

  constructor(data: any) {
    Object.assign(this, data);

    this.Works = [];

    if (Array.isArray(data.Works)) {
      for (const work of data.Works) {
        this.Works.push(new MtWork(work, this));
      }
    }
  }
}

export class MtWork {
  Id: string;
  ObjectType: number;
  Designation: string;
  SortOrder?: number;
  State: number;
  StateDisplayText: string;
  ExecutionDate: string;
  ScheduledExecutionDate: string;
  Object: MtObject;
  Tasks: MtTask[];
  AllowDeletion: boolean = false;
  WorkTypeDurationMode: string;
  Duration: number;

  constructor(data: any, object: MtObject) {
    Object.assign(this, data);

    this.Object = object;
    this.Tasks = new Array<MtTask>();

    if (Array.isArray(data.Tasks)) {
      for (const task of data.Tasks) {
        this.Tasks.push(new MtTask(task));
      }
    }
  }
}

export class MtTask {
  Id: string;
  Designation: string;
  Description: string;
  SortOrder?: number;
  AllowMultiSelectResults: boolean;
  AllowSelectResultsFromSingleCategory: boolean;
  ResultsRequired: boolean;
  Finished?: boolean;
  PositionTypeId: string;
  TaskTypeId: string;
  RelevantForEdges: boolean;
  RelevantForStartNode: boolean;
  RelevantForEndNode: boolean;
  RelevantForMidNodes: boolean;
  Results: MtResult[];
  Geometry?: Geometry;
  AllowPointGeometries?: boolean;
  AllowLineGeometries?: boolean;
  AllowPolygonGeometries?: boolean;

  constructor(data: any) {
    Object.assign(this, data);
    this.Results = new Array<MtResult>();

    if (Array.isArray(data.Results)) {
      for (const result of data.Results) {
        this.Results.push(new MtResult(result));
      }
    }
  }
}

export class MtPositionType {
  Id: string;
  ResultTypes: MtResultType[] = [];
  DefaultResultTypes: MtResultType[] = [];
  AutoCompleteResultTypes: MtResultType[] = [];
  SortOrders: { type: MtResultType; index: number }[] = [];
  Designations: { type: MtResultType; designation: string }[] = [];
  FollowingTaskTypeIds: { type: MtResultType; taskTypeId: string }[] = [];
  InvisibleExpressions: { type: MtResultType; expression: string }[] = [];

  constructor(data: any) {
    Object.assign(this, data);
  }
}

export class MtResultPosType {
  ParentId: string;
  Designation: string;
  ResultTypeId: string;
  IsSelectedByDefault: boolean;
  IsSelectedByAutoComplete: boolean;
  SortOrder: boolean;
  IdRefMtTaskTypeFollowing: string;
  InvisibleExpression: string;

  constructor(data: any) {
    Object.assign(this, data);
  }
}

export class MtResultType {
  Id: string;
  Designation: string;
  Description: string;
  Category: string;
  Quantity?: number;
  SetTaskCompleteOnSelection: boolean;
  Caption: string;
  Unit: string;
  UnitPrice: number;
  Code: string;
  IsQuantityRequired: boolean;
  IsPhotoRequired: boolean;
  IsDescriptionRequired: boolean;
  IdRefMtTaskTypeFollowing: string;
  IsGeometryRequired?: boolean;

  constructor(data: any) {
    Object.assign(this, data);
  }
}
export class MtResult {
  Id: string;
  ResultTypeId: string;
  Designation: string;
  Description: string;
  Quantity?: number;
  Documents: MtDocument[];
  Code: string;
  Category: string;
  Date: string;
  Time: string;
  Caption: string;
  Unit: string;
  UnitPrice: number;
  Price: number;
  PhotoImpossibleText?: string;

  constructor(data: any) {
    Object.assign(this, data);
    this.Documents = new Array<MtDocument>();

    if (Array.isArray(data.Documents)) {
      for (const doc of data.Documents) {
        this.Documents.push(new MtDocument(doc));
      }
    }
  }
}
export class MtDocument {
  Id: string;
  Designation: string;
  Object: string;
  Kind: string;
  Date: string;
  InsertAt: Date;

  constructor(data: any) {
    Object.assign(this, data);
  }
}

export class Order {
  Id: string;
  Designation: string;
  Date: string;
  Remark: string;
  CountWorks: number;
  CountWorksOpen: number;
  CountWorksPartial: number;
  CountWorksDone: number;
  constructor(data: any) {
    Object.assign(this, data);
  }
}

export class MasterElement {
  Designation: string;

  constructor(data: any) {
    Object.assign(this, data);
  }
}

export class BCEMobileConfiguration {
  GraphicalModelId: string = null;
  MapName: string = null;
  ArenaDefinitionDocumentId: string = null;
  ArenaLayouts: Array<ArenaLayout> = null;

  constructor() {}
}

export class ArenaLayout {
  objectType: string = null; //parsing cannot translate lower case of first letter to upper
  objectTypeValue: number;
  usage: string = null;
  layoutPath: string = null;
  layoutPathCaption: string = null;

  constructor() {}
}

export enum WorkModeEnum {
  Default = 0, //Order and Tickets (if exists)
  Ticket = 1, //Only Ticket
  Order = 2, //Only Order
}

export enum DocumentKind {
  Datei = 'FILE',
  Bild = 'IMAGE',
}

export class Reminder {
  Id: string;
  ParentId: string;
  IsActive: boolean;

  constructor(data: any) {
    Object.assign(this, data);
  }
}
